module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcolorbond.net.au/images/testimonials-b84dada0036a14fe34bd654c197eb056.jpg";